import React from 'react'
import VideoContainer from '../component/VideoContainer'

const VideoPlayingTab = () => {
  return (
    <div>
        <VideoContainer/>
    </div>
  )
}

export default VideoPlayingTab